import { useNavigate } from "react-router-dom";
import { ROUTES } from "../routes/constants";
import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";

const Redirect = () => {
  const { accounts } = useMsal();

  const navigate = useNavigate();

  useEffect(() => {
    if (accounts.length) {
      navigate(ROUTES.HOME);
    }
  }, [accounts, navigate]);

  return <></>;
};

export default Redirect;
